<template>
<!-- Make Navbar fixed, transparent, and disappear on scroll
https://www.w3schools.com/howto/howto_js_navbar_hide_scroll.asp -->
  <div class="tl pl3 w-80-ns w-90 dt center-ns">
    <div class="site tl w-50-ns w-90 dib pv4-ns pv3">
      <router-link to="/" class="pb3-ns pb2 black 1 db f2-ns f3 fw4 link">All<span class="red">on</span> Construction</router-link>
      <div class="black link db f5"><a :href="info.tel" class="dim black link">{{info.num}}</a> | <a class="dim red link" :href="info.link" target="_blank">{{info.lic}} </a></div>
    </div>
    <div v-if="mobile">
      <label class="toggle pa4">
        <input
          type="checkbox" id="checkbox" 
          @click="toggleMenu()">
        <div>
          <div>
            <span />
            <span />
          </div>
          <svg>
            <path d="M22,22 L2,22 C2,11 11,2 22,2 C33,2 42,11 42,22" />
          </svg>
          <svg>
            <path d="M22,22 L2,22 C2,11 11,2 22,2 C33,2 42,11 42,22" />
          </svg>
        </div>
      </label>
      <transition name="fade">
        <div
          v-if="showMenu"
          class="nav-container w-100 dt f2"
        >
          <div class="nav-mobile dtc v-mid">
            <router-link
              v-for="(route, index) in routes"
              :key="index"
              class="link tab tc center"
              :to="route.path"
            >
              <div class="h3 dim dt w-100">
                <div
                  v-if="showMenu"
                  class="name dtc v-mid fw1" :class="{ active: isActive(route) }"
                >
                  {{ route.name }}
                </div>
              </div>
            </router-link>
            <div class="f2 w-100 tc pt5">Allon<span class="red"> Construction</span> </div>
            <div class="center tc link social fw4">
              <!-- <div class="f3 pb2">Free estimate</div> -->
              <div class=" f4 dib ph2"><a :href="info.tel" class="dim black link">{{info.num}}</a> |</div>
              <div class="f4 dib"><a class="dim red link" :href="info.link" target="_blank">{{info.lic}} </a></div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div v-else class="w-50 dib tr">
      <div class="menu" >
        <router-link v-for="(route, i) in routes" :key="i" :to="route.path" class="ph2 link dib black f4 dim">{{route.name}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
var keys = {37: 1, 38: 1, 39: 1, 40: 1};
// modern Chrome requires { passive: false } when adding event
var supportsPassive = false;
try {
  window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
    get: function () { supportsPassive = true; } 
  }));
} catch(e) {}

var wheelOpt = supportsPassive ? { passive: false } : false;
var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

export default {
  name: 'NavBar',
  props: ['site', 'mobile', 'info'],
  data() {
    return {
      stopScroll: false,
      showMenu: false,
      routes: []
    };
  },
  created() {
    this.$router.options.routes.forEach(route => {
        this.routes.push({
            name: route.name,
            path: route.path
        })
    })
  },
  watch:{
    $route (to, from){
      if(this.showMenu) {
        this.showMenu = false
        this.enableScroll()
        document.getElementById('checkbox').checked = !document.getElementById('checkbox').checked
      }
    }
  }, 
  methods:{
    isActive: function (tab) {
      return tab.path === this.$router.currentRoute.path
    },
    toggleMenu() {
      window.scrollTo(0,0);
      this.showMenu = !this.showMenu
      if(this.showMenu) this.disableScroll()
      else this.enableScroll()
    },
    preventDefault(e) {
      e.preventDefault();
    },
    preventDefaultForScrollKeys(e) {
      if (keys[e.keyCode]) {
        this.preventDefault(e);
        return false;
      }
    },

    // call this to Disable
    disableScroll() {
      console.log('scrolling disabled')
      window.addEventListener('DOMMouseScroll', this.preventDefault, false); // older FF
      window.addEventListener(wheelEvent, this.preventDefault, wheelOpt); // modern desktop
      window.addEventListener('touchmove', this.preventDefault, wheelOpt); // mobile
      window.addEventListener('keydown', this.preventDefaultForScrollKeys, false);
    },

    // call this to Enable
    enableScroll() {
      console.log('scrolling enabled')
      window.removeEventListener('DOMMouseScroll', this.preventDefault, false);
      window.removeEventListener(wheelEvent, this.preventDefault, wheelOpt); 
      window.removeEventListener('touchmove', this.preventDefault, wheelOpt);
      window.removeEventListener('keydown', this.preventDefaultForScrollKeys, false);
    }
  }
};
</script>

<style scoped>
.tab {
  color:rgb(0, 0, 0);
}
.nav {
  height: 3rem;
  width: 90%;
}
.menu a.router-link-exact-active, .nav a.router-link-exact-active {
  color:rgb(182, 40, 40);
}

.social svg {
  -webkit-filter: invert(100%); /* safari 6.0 - 9.0 */
          filter: invert(100%);
}
.logo {
  /* padding-top: 1.6rem;
  padding-bottom: 3rem;
  letter-spacing: .1em; */
  /* transition: all .3s ease-in; */
}
.logo:hover {
  /* letter-spacing: .2em; */
  cursor: pointer;
}
.nav-container {
  height: 100%;
  width: 100%;
  position: fixed; /* Stay in place */
  z-index: 1000; /* Sit on top */
  left: 0;
  top: 0;
  background-color: white; /* Black fallback color */
  background-color: rgba(240, 228, 228, 0.9); /* Black w/opacity */
  overflow-x: hidden; /* Disable horizontal scroll */
  transition: 0.7s; /* 0.5 second transition effect to slide in or slide down the overlay (height or width, depending on reveal) */
}
.nav-mobile {
  table-layout: fixed;
  z-index: 1001;
}
.dtr {
    display: table-row;
    width: 100%;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .7s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.title {
  /* text-transform: uppercase; */
  /* letter-spacing: .1em; */
  /* position: absolute; */
  /* bottom: 5%; */
  color:rgb(182, 40, 40);
  /* top: 12%; */
}
.active {
  color: rgb(182, 40, 40);
  /* font-style: italic; */
  font-weight: 400;
  /* letter-spacing: .1em; */
  /* text-transform: uppercase; */
}

/* Hamburger Menu Styling */
.toggle {
  display: block;
  cursor: pointer;
  position: absolute;
  top: 0%;
  right: 0%;
  z-index: 1001; /* Sit on top */
}
.toggle input {
  display: none;
}
.toggle input + div {
  width: 20px;
  height: 14px;
  position: relative;
}
.toggle input + div div {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  transition: -webkit-transform .5s ease;
  transition: transform .5s ease;
  transition: transform .5s ease, -webkit-transform .5s ease;
}
.toggle input + div div span {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
}
.toggle input + div div span:first-child {
  top: 0;
}
.toggle input + div div span:first-child:before, .toggle input + div div span:first-child:after {
  top: 0;
}
.toggle input + div div span:last-child {
  bottom: 0;
}
.toggle input + div div span:last-child:before, .toggle input + div div span:last-child:after {
  bottom: 0;
}
.toggle input + div div span:before, .toggle input + div div span:after {
  content: '';
  display: block;
  width: 47%;
  height: 2px;
  border-radius: 1px;
  background: rgb(182, 40, 40);
  position: absolute;
  -webkit-backface-visibility: hidden;
  transition: border-radius .3s ease, background .4s ease, -webkit-transform .5s ease;
  transition: transform .5s ease, border-radius .3s ease, background .4s ease;
  transition: transform .5s ease, border-radius .3s ease, background .4s ease, -webkit-transform .5s ease;
}
.toggle input + div div span:before {
  left: 0;
  -webkit-transform-origin: 0 50%;
          transform-origin: 0 50%;
  -webkit-transform: translate(1px, 0) scaleX(1.1);
          transform: translate(1px, 0) scaleX(1.1);
}
.toggle input + div div span:after {
  right: 0;
  -webkit-transform-origin: 100% 50%;
          transform-origin: 100% 50%;
  -webkit-transform: translate(-1px, 0) scaleX(1.1);
          transform: translate(-1px, 0) scaleX(1.1);
}
.toggle input + div svg {
  display: block;
  fill: none;
  stroke: rgb(182, 40, 40);
  stroke-width: 2px;
  width: 44px;
  height: 44px;
  stroke-linecap: round;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -22px 0 0 -22px;
  stroke-dasharray: 0 82.801 8 82.801;
  stroke-dashoffset: 82.801;
  -webkit-transform-origin: 50% 50%;
          transform-origin: 50% 50%;
  -webkit-backface-visibility: hidden;
  -webkit-transform: scale(1);
          transform: scale(1);
  transition: stroke-dashoffset .5s ease, stroke-dasharray .6s ease, stroke .4s ease, -webkit-transform .5s ease;
  transition: stroke-dashoffset .5s ease, stroke-dasharray .6s ease, transform .5s ease, stroke .4s ease;
  transition: stroke-dashoffset .5s ease, stroke-dasharray .6s ease, transform .5s ease, stroke .4s ease, -webkit-transform .5s ease;
}
.toggle input + div svg:nth-child(3) {
  -webkit-transform: rotate(180deg) scale(1);
          transform: rotate(180deg) scale(1);
}
.toggle input:checked + div div {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}
.toggle input:checked + div div span:before, .toggle input:checked + div div span:after {
  background: rgb(182, 40, 40);
}
.toggle input:checked + div div span:first-child:before {
  -webkit-transform: rotate(45deg) translate(2.2px, -3px) scaleX(1.05);
          transform: rotate(45deg) translate(2.2px, -3px) scaleX(1.05);
}
.toggle input:checked + div div span:first-child:after {
  -webkit-transform: rotate(-45deg) translate(-2.2px, -3px) scaleX(1.05);
          transform: rotate(-45deg) translate(-2.2px, -3px) scaleX(1.05);
}
.toggle input:checked + div div span:last-child:before {
  -webkit-transform: rotate(-45deg) translate(2.2px, 3px) scaleX(1.05);
          transform: rotate(-45deg) translate(2.2px, 3px) scaleX(1.05);
}
.toggle input:checked + div div span:last-child:after {
  -webkit-transform: rotate(45deg) translate(-2.2px, 3px) scaleX(1.05);
          transform: rotate(45deg) translate(-2.2px, 3px) scaleX(1.05);
}
.toggle input:checked + div svg {
  stroke-dashoffset: 62;
  stroke-dasharray: 0 82.801 62 82.801;
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
  stroke:rgb(182, 40, 40);
;
}
.toggle input:checked + div svg:nth-child(3) {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

html {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
}

* {
  box-sizing: inherit;
}
*:before, *:after {
  box-sizing: inherit;
}
</style>
